import { NgModule } from '@angular/core';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UserComponent } from 'app/layout/common/user/user.component';
import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
    declarations: [
        UserComponent,
        EditProfileComponent
    ],
    imports     : [
        MatLegacyButtonModule,
        MatDividerModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatLegacyMenuModule,
        MatProgressSpinnerModule,
        SharedModule
    ],
    exports     : [
        UserComponent
    ],
    providers   : [AngularFirestoreModule]
})
export class UserModule
{
}
